import { create } from 'zustand';

import { FeatureFlagStore } from './feature-flags.types';

export const useFeatureFlagStore = create<FeatureFlagStore>()((set, get) => ({
  launchDarklyFlags: {},

  setLaunchDarklyFlags: (launchDarklyFlags) => set({ launchDarklyFlags }),
  getLaunchDarklyFlag: (flag) => get().launchDarklyFlags[flag] ?? false,
}));
